<template>
  <div class="bggray">
    <app-header />
    <div class="percen-wrap clearfix">
      <aside>
        <h2>个人中心</h2>
        <h3>
          <span>{{userName}}</span>
        </h3>
        <ul>
          <li><a href="#" @click="toAccountManage()">账号管理</a></li>
          <router-link to="/personal/orderlist" tag="li">我的订单</router-link>
          <router-link to="/personal/powerlist" tag="li">我的产品</router-link>
          <router-link to="/personal/extraproduct" tag="li">附加产品</router-link>
          <!-- <router-link to="/personal/cardpay" tag="li">点卡充值</router-link> -->
          <li><a href="#" @click="cardpay()">点卡充值</a></li>
          <router-link to="/personal/cardlist" tag="li">历史充值</router-link>
          <!-- coupon -->
          <!-- <router-link to="/personal/coupon" tag="li">我的礼券</router-link> -->
        </ul>
      </aside>
      <div class="r-con">
        <router-view></router-view>
      </div>
    </div>

    <app-footer />
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
export default {
  data() {
    return {
      userName: this.$storage.getUserName()
    };
  },
  methods: {
    
    toAccountManage(){
      this.$get("/user/accountManage").then(response => {
        if(response.code === 0){
          window.open(response.data);
        } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
      })
    },
    cardpay(){
      this.$router.push("/personal/cardpay/"  + this.userName);
      return false;
    }
  },
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.percen-wrap {
  width: 1100px;
  margin: 50px auto 35px;
  overflow: hidden;
  position: relative;
  aside {
    // float: left;
    background: #fff;
    width: 234px;
    margin-right: 6px;
    position: absolute;
    left: 0;
    top: 0;
    // min-height: 1000px;
    height: 100%;
    h2 {
      @include vertical-center(100%, 60px);
      @include fc(25px, #222);
      border-bottom: 1px solid #d6d6d6;
    }
    h3,
    h4,
    ul li {
      @include vertical-center(100%, 54px);
    }
    h3 {
      @include fc(18px, #222);
      border-bottom: 1px solid #d6d6d6;
      span {
        &:before {
          content: "";
          display: inline-block;
          @include wh(30px, 30px);
          vertical-align: middle;
          margin-right: 10px;
          background: url("~@/assets/images/icon/person.png") no-repeat;
        }
      }
    }
    h4 {
      a {
        @include fc(20px, #222);
      }
    }
    ul {
      li {
        @include fc(20px, #222);
        cursor: pointer;
        a{
          color: #222;
        }
        &.is-active {
          background: #166fff;
          color: #fff;
        }
      }
    }
  }
  .r-con {
    // float: right;
    width: 860px;
    margin-left: 240px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/Personal.vue